/** Orbit camera around a point: the angle advances with time. Pure so it can be tested. */
export interface Orbit { cx: number; cy: number; cz: number; radius: number; height: number; speed: number; phase: number }

export function orbitAt(o: Orbit, t: number): { x: number; y: number; z: number } {
  const a = o.phase + o.speed * t;
  return { x: o.cx + Math.cos(a) * o.radius, y: o.cy + o.height, z: o.cz + Math.sin(a) * o.radius };
}
